import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notification, ToastService } from 'src/app/core/services/toast.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('animationNotification', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class ToastComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private abonnement!: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.abonnement = this.toastService.notifications$.subscribe(
      notifications => this.notifications = notifications
    );
  }

  ngOnDestroy(): void {
    this.abonnement?.unsubscribe();
  }

  retirerNotification(id: number): void {
    this.toastService.retirer(id);
  }

  action(idNotification: number, action: 'confirm' | 'cancel'): void {
    this.toastService.declencherAction(idNotification, action);
  }

  obtenirIcone(type: string): string {
    return type;
  }
}
